<ng-container *transloco="let t">
  <editable-text
    appNavBreadcrumb
    [label]="spStrategy()?.name ?? ''"
    [tooltipText]="t('sp-strategy-group-page.change_strategy_group_name')"
    (textChange)="strategyNameInput.set($event); updateStrategyName()"
  />
  @if (!loading() && tacosStrategyEx() && !createSbStrategy()) {
    <div class="container mx-auto flex min-h-full flex-col rounded-lg bg-white px-10 py-6">
      <state-badge
        class="mb-2"
        [state]="tacosStrategyEx()!.state"
        [loading]="stateUpdateLoading()"
        (onClick)="updateStrategyGroupState($event)"
        [disabled]="!!isReadOnly()"
      />
      <div class="flex w-full gap-2 pb-3">
        <strategy-info-bloc (onClick)="openTargetModal()" [disabled]="!!isReadOnly()">
          <div title class="text-sm uppercase text-gray-500">{{ t("strategy-table.target") }}</div>
          @if (tacosStrategyEx()) {
            <div body class="ml-0.5 font-medium">{{ tacosStrategyEx()!.tacosTarget! * 100 | number: "1.0-1" }} %</div>
          } @else {
            <div body class="mt-1 h-6 w-14 animate-pulse rounded-md bg-gray-200"></div>
          }
        </strategy-info-bloc>
      </div>

      <ITabs [tabs]="tabs()" [(activeTab)]="activeTab" />

      <div class="flex-1 pt-5">
        @if (selectedSection() === Section.STATS) {
          @if (tacosStrategyEx() && spStrategy()) {
            <tacos-stats [tacosStrategy]="tacosStrategyEx()!" />
          }
        } @else if (selectedSection() === Section.PRODUCTS) {
          @if (tacosStrategyEx() && spStrategy() && am()) {
            <tacos-products
              [tacosStrategy]="tacosStrategyEx()!"
              [sbAsins]="sbAsins()"
              [missingAsinsInSb]="missingAsinsInSb()"
              [am]="am()!"
              [isReadOnly]="!!isReadOnly()"
            />
          }
        } @else if (selectedSection() === Section.CAMPAIGNS) {
          @if (spStrategy() && am() && tacosStrategyEx()) {
            <tacos-ad-types
              [am]="am()!"
              [tacosStrategy]="tacosStrategyEx()!"
              [sbAsins]="sbAsinsString()"
              [missingAsinsInSb]="missingAsinsInSb()"
              [isReadonly]="!!isReadOnly()"
            />
          }
        } @else if (selectedSection() === Section.ACTIVITIES) {
          <div class="ag-theme-quartz h-[30rem]">
            <app-activity-component
              [activityFilter]="activityFilter()"
              [hideEntityColumn]="true"
              gridConfigStorageKey="strategyActivities"
            />
          </div>
        }
      </div>
    </div>
  } @else if (loading()) {
    <div class="flex h-full items-center justify-center">
      <app-spinner [display]="true" [main]="false" size="m" type="default" />
    </div>
  }

  <ng-template #targetModal>
    <div class="w-[20vw]">
      <div class="py-5">
        <IInput
          [label]="t('strategy-table.target')"
          [placeholder]="t('strategy-table.target')"
          [type]="'number'"
          [min]="0"
          [max]="100"
          [value]="tacosStrategyEx()?.tacosTarget! * 100 | number: '1.0-1'"
          [autoFocus]="true"
          [trailing]="true"
          icon="icon-[mdi--percent]"
          (valueChange)="tacosTargetInput.set(+$event)"
        />
      </div>
      <div class="mt-4 flex justify-end gap-2">
        <IButton color="white" [label]="t('common.cancel')" (onClick)="hideModal()" />
        <IButton [label]="t('common.save')" (onClick)="updateTacosTarget()" [loading]="modalLoading()" />
      </div>
    </div>
  </ng-template>

  <ng-template #editNameModal>
    <div class="w-[20vw]">
      <div class="py-5">
        <IInput
          [label]="t('common.name')"
          [placeholder]="t('common.name')"
          [value]="spStrategy()?.name!"
          [autoFocus]="true"
          [trailing]="true"
          (valueChange)="strategyNameInput.set($event)"
        />
      </div>
      <div class="mt-4 flex justify-end gap-2">
        <IButton color="white" [label]="t('common.cancel')" (onClick)="hideModal()" />
        <IButton [label]="t('common.save')" (onClick)="updateStrategyName()" [loading]="modalLoading()" />
      </div>
    </div>
  </ng-template>
</ng-container>
